import LegalShell from "./LegalShell";

export default function Refund() {
  return (
    <LegalShell eyebrow="Refund & Cancellation" title="Fair, fast, on your terms.">
      <p>
        We want StyleMe to feel like a great purchase, not a regretted one. This policy explains
        when refunds apply and how to cancel.
      </p>

      <h2>1. Premium — 7-day money-back guarantee</h2>
      <p>
        If you subscribe to the <b>Premium</b> plan and decide it's not for you within 7 calendar
        days of payment, we'll refund the full amount — no questions asked. Just email
        <a href="mailto:srichandrab@stylenme.com"> srichandrab@stylenme.com</a> from your account
        email with the subject "Premium refund".
      </p>

      <h2>2. Basic plan</h2>
      <p>
        Basic subscriptions are non-refundable once the first AI look is generated under that
        plan. If you haven't generated any look yet, write to us within 48 hours of payment and
        we'll process a full refund.
      </p>

      <h2>3. How refunds are issued</h2>
      <ul>
        <li>Refunds are credited to the original Razorpay payment method.</li>
        <li>Processing time: typically 5–7 business days, depending on your bank.</li>
        <li>Once a refund is issued, premium features end immediately.</li>
      </ul>

      <h2>4. Cancellation</h2>
      <p>
        Today, StyleMe plans are 30-day one-time payments rather than auto-renewing subscriptions —
        so cancelling is simply not paying for the next month. Your benefits stay active until the
        end of the period you've already paid for.
      </p>
      <p>
        If we introduce auto-renewing subscriptions in future, you'll be able to cancel them with
        one click from your account page, with no penalty.
      </p>

      <h2>5. Disputes & chargebacks</h2>
      <p>
        Please reach out to us before raising a chargeback — most issues are resolved within a
        single email. Chargebacks raised before contacting us may result in account suspension while
        we investigate.
      </p>

      <h2>6. Exceptions</h2>
      <ul>
        <li>Where local law mandates a different refund standard (e.g., EU consumer rights), the more user-friendly of the two applies.</li>
        <li>Refunds may be partially withheld where there's clear evidence of abuse (e.g., generating dozens of looks before requesting a refund).</li>
      </ul>

      <h2>7. Contact</h2>
      <p>
        All refund and cancellation requests: <a href="mailto:srichandrab@stylenme.com">srichandrab@stylenme.com</a>.
      </p>
    </LegalShell>
  );
}
